import { useParams } from "react-router-dom";
import BestsellerSection from "../components/productComponents/BestsellerSection";
import products from "../data/products";

const CategoryPage = () => {
  const { categoryName } = useParams();
  const normalized = (categoryName || "").toLowerCase();

  // Match case-insensitively
  const categoryProducts = products.filter(
    (p) => (p.category || "").toLowerCase() === normalized
  );

  // Use canonical label from data if available, otherwise format the param
  const displayName =
    (categoryProducts[0] && categoryProducts[0].category) ||
    (categoryName ? categoryName.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "");

  const bestSellers = categoryProducts.filter((p) => p.isBestSeller === true);

  return (
    <div className="w-full">
      <h1 className="text-2xl font-bold p-6">{displayName}</h1>

      {/* CATEGORY PRODUCTS */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 p-6">
        {categoryProducts.length ? (
          categoryProducts.map((item) => (
            <div key={item._id} className="border rounded p-3">
              <img src={item.image} alt={item.name} />
              <h3 className="mt-2">{item.name}</h3>
            </div>
          ))
        ) : (
          <div className="col-span-full p-6 text-center text-gray-500">
            No products found for "{displayName}"
          </div>
        )}
      </div>

      {/* CATEGORY-WISE BESTSELLER */}
      <BestsellerSection
        title={`${displayName} Bestsellers`}
        products={bestSellers}
      />
    </div>
  );
};

export default CategoryPage;